// @ts-check
import React from 'react';

import Box from '@liquidweb-dev/undercurrent/Box';
import Button from '@liquidweb-dev/undercurrent/Button';
import Skeleton from '@liquidweb-dev/undercurrent/Skeleton';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import BrandLogo from 'components/atoms/BrandLogo';
import useLogout from 'modules/oidc/useLogout';
import useAccountDetails from 'modules/queries/account/useDetails';
import { Link as RouterLink } from 'react-router-dom';
import accountStatuses from 'utility/constants/accountStatuses';

const NavAction = () => {
	const { data: accountDetails, isLoading } = useAccountDetails(
		{
			alsowith: ['accountContact'],
		},
		{
			refetchInterval: (data) => {
				if (data?.account_status === accountStatuses.PENDING_NEW) {
					return 10000;
				}
				return false;
			},
		},
	);

	const isNewAccount =
		accountDetails?.account_status === accountStatuses.PENDING_NEW;

	if (isLoading) {
		return (
			<Skeleton variant="rounded" sx={{ height: '40px', width: '170px' }} />
		);
	}

	return (
		<Button loading={isNewAccount} component={RouterLink} to="/" size="large">
			{!isNewAccount ? (
				<>
					<Typography
						sx={({ vars }) => ({
							color: vars.palette.uc.text.strong,
							display: { xs: 'none', md: 'flex' },
						})}
					>
						Go to your dashboard
					</Typography>
					<Typography
						sx={({ vars }) => ({
							color: vars.palette.uc.text.strong,
							display: { xs: 'flex', md: 'none' },
						})}
					>
						Dashboard
					</Typography>
				</>
			) : (
				<Typography sx={({ vars }) => ({ color: vars.palette.uc.text.strong })}>
					Setting up account
				</Typography>
			)}
		</Button>
	);
};

/**
 * @param {object} props
 * @param {import('@liquidweb-dev/undercurrent/Button').ButtonProps} [props.logoutButtonProps]
 */
const OrderConfirmation = ({ logoutButtonProps }) => {
	const logout = useLogout();

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				gap: 200,
				width: '100%',
			}}
		>
			<BrandLogo />
			<Stack direction="row" alignItems="center" gap={{ xs: 100, md: 200 }}>
				<NavAction />
				<Button
					variant="link"
					onClick={logout}
					size="large"
					{...logoutButtonProps}
				>
					Logout
				</Button>
			</Stack>
		</Box>
	);
};

export default OrderConfirmation;
